import {createSlice, PayloadAction} from '@reduxjs/toolkit';
import {IRootState} from "./configureStore";

export interface IUser {
  id: number;
  name: string;
  login: string;
  email: string;
  roles?: string[];
  timeZone: string;
  f2Auth: boolean;
}

export const USER_BIRTHDAY_ROLE = "USER_BIRTHDAY_ROLE"
export const ROLE_ADMIN = "ROLE_ADMIN"

export const initialState = {
  user: {} as IUser
};


const slice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    setUser: (state: IRootState, action: PayloadAction<IUser>) => {
      state.user = action.payload
    },
    clearUser: (state: IRootState) => {
      state.user = {} as IUser
    },
  },
});

const { actions, reducer } = slice;

export { actions, reducer };
